/**
 * Created by zzy on 2019/8/6.
 */
// 引入 ECharts 主模块
let echarts = require('echarts/lib/echarts')
// 引入曲线图
require('echarts/lib/chart/line')
// 引入提示框
require('echarts/lib/component/tooltip')
require('echarts/lib/component/legendScroll')
export default {
  name: 'LineChart',
  data () {
    return {
      echarts: echarts,
      lineChart: null
    }
  },
  props: {
    id: {
      type: String,
      default: 'line-chart'
    },
    source: {
      type: Array,
      default: []
    },
    color: {
      type: Array,
      default: []
    },
    gridBottom: {
      type: Number,
      default: 60
    },
    legendBottom: {
      type: Number,
      default: 5
    }
  },
  mounted () {
    // this.draw()
  },
  methods: {
    draw () {
      let lineChartElement = document.getElementById(this.id)
      if (!lineChartElement) {
        return
      }

      if (!this.lineChart) {
        this.lineChart = this.echarts.init(lineChartElement)
      } else {
        this.lineChart.clear()
      }

      let series = []
      if (this.source[0] && this.source[0].length) {
        for (let i = 0; i < this.source[0].length / 2; i++) {
          let obj = {type: 'line', color: this.color[i]}
          series.push(obj)
        }
      }

      // 绘制图表
      this.lineChart.setOption({
        legend: {
          bottom: this.legendBottom
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        dataset: {
          source: this.source
        },
        grid: {
          top: 20,
          bottom: this.gridBottom,
          left: 50,
          right: 30
        },
        xAxis: { type: 'time' },
        yAxis: { type: 'value' },
        series: series,
        animation: true,
        animationDuration: 2000,
        animationEasing: 'bounceOut'
      })
      // window.addEventListener('resize', () => {
      //   lineChart.resize()
      // })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/echarts/LineChart/LineChart.js